<div class="editor-app" ui-view></div>
